import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTooltipElement } from './OneUxTooltipElement.js';
export const register = getRegisterFunction(OneUxTooltipElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tooltip': OneUxTooltipElement;
    "tooltip-9f58c2a4e49155639a8a87c5f91477c1": OneUxTooltipElement;
  }
}